import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShareScreen"><Path d="M9 11.5L12 8.5L15 11.5M12 15.5V9M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShareScreen;
